import { keys } from "lodash";

const deviceColors = {
  mobile: "#955BFF",
  desktop: "#AD8EE6",
  tablet: "#D0BBF5",
} as const;

const operatingSystemColors = {
  ios: "#117F46",
  android: "#1D995B",
  osx: "#3EE192",
  windows: "#A7F058",
  "windows-phone": "#7AD21D",
  blackberry: "#3CA803",
} as const;

const publishingMethodColors = {
  "official-publishing-app": "#F86045",
  "official-ads-app": "#F8856E",
  "publishing-solution": "#F8A291",
  "other-network-app": "#FAC6BB",
} as const;

export type PublishingMethod = keyof typeof publishingMethodColors;

export type Device = keyof typeof deviceColors;

export type OperatingSystem = keyof typeof operatingSystemColors;

export function getDevicePublishingMethodColor(
  publishingMethod: PublishingMethod
) {
  return publishingMethodColors[publishingMethod];
}

export function getDeviceColor(device: Device) {
  return deviceColors[device];
}

export function getOperatingSystemColor(os: OperatingSystem) {
  return operatingSystemColors[os];
}

export function getAllDevices() {
  return keys(deviceColors) as Device[];
}

export function getAllDeviceOperatingSystems() {
  return keys(operatingSystemColors) as OperatingSystem[];
}

export function getAllDevicePublishingMethods() {
  return keys(publishingMethodColors) as PublishingMethod[];
}
